import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";
import { useDispatch } from "react-redux";
import {
  AlertBannerContext,
  API_RESPONSE_CODE,
  ALERT_BANNER_CODE,
  ALERT_BANNER_CODE_SEVERITY
} from "@kivunova/kivufrontendcommon";
import { fetchGraphQL } from "../../Graphql/utils";
import { getCompanyBasicInfoQuery } from "../../Graphql/querries/companyQuery";
import { setCompanyCurrencyCode } from "../../store/slices/companySlice";

interface GetCompanyBasicInfoResponse {
  getCompanyBasicInfo: {
    code: string;
    company: {
      name: string;
      currencyCode: string;
    } | null;
  };
}

/**
 * Loads company currency for the current session (dashboard formatting).
 * Tenant businessType lives on the access token — use platform config or JWT, not this slice.
 */
export const useGetCompanyBasicInfo = () => {
  const { setAlert } = useContext(AlertBannerContext);
  const dispatch = useDispatch();

  return useMutation({
    mutationKey: ["getCompanyBasicInfo"],
    mutationFn: async () => {
      const response = await fetchGraphQL<
        GetCompanyBasicInfoResponse,
        Record<string, never>
      >(getCompanyBasicInfoQuery, {}, setAlert);

      const { code, company } = response.getCompanyBasicInfo;

      if (code !== API_RESPONSE_CODE.OK) {
        setAlert({
          severity: ALERT_BANNER_CODE_SEVERITY.ERROR,
          code: code as unknown as ALERT_BANNER_CODE
        });
        return null;
      }

      return company;
    },
    onSuccess: (company) => {
      if (company?.currencyCode) {
        dispatch(setCompanyCurrencyCode(company.currencyCode));
      }
    }
  });
};
